import { setAccentLink } from "./functions/setAccentLink";

const themeSwitcher = document.querySelector(".switch-theme__input");

export { setAccentLink, themeSwitcher };
